import { render, staticRenderFns } from "./TitleBackdrops.vue?vue&type=template&id=21c1b726&"
import script from "./TitleBackdrops.vue?vue&type=script&lang=ts&"
export * from "./TitleBackdrops.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBackdrops.vue?vue&type=style&index=0&id=21c1b726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports